import styled from '@emotion/styled';
import { Dialog } from '@fhl-world/salmon-ui';

const Wrapper = styled.div`
	max-width: 312px;
	padding: 24px;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
`;

const Header = styled.p`
	font-size: 20px;
	font-weight: 600;
	line-height: 28px;
	text-align: left;
	margin: 0 0 10px;
`;
const Text = styled.p`
	font-size: 16px;
	font-weight: 400;
	line-height: 22px;
	text-align: left;
	margin: 0;
`;

type InactivityModalProps = {
	open: boolean;
};
const InactivityModal = (props: InactivityModalProps) => {
	const { open } = props;
	return (
		<Dialog open={open}>
			<Wrapper>
				<Header>You were inactive</Header>
				<Text>Please, press any button to continue</Text>
			</Wrapper>
		</Dialog>
	);
};

export default InactivityModal;
